import {
  isApiResponse,
  isApiSuccessCode,
  type ApiResponse,
} from '@/services/apiResponse';
import { getNebulithUserApiUrl } from '@/services/util';
import { persistAuthTokens } from '@/utils/authSession';

type RefreshTokenData = {
  accessToken?: string;
  refreshToken?: string;
};

let refreshPromise: Promise<boolean> | null = null;

const parseRefreshResponse = (json: unknown): RefreshTokenData | null => {
  if (!isApiResponse(json) || !isApiSuccessCode(json.code)) {
    return null;
  }
  return (json as ApiResponse<RefreshTokenData>).data;
};

/** 调用 nebulith-user 刷新 token，使用 fetch 避免与全局 request 拦截器循环 */
export const refreshAuthTokens = async (): Promise<boolean> => {
  const refreshToken = localStorage.getItem('refreshToken');
  if (!refreshToken) {
    return false;
  }

  if (!refreshPromise) {
    refreshPromise = (async () => {
      try {
        const response = await fetch(
          getNebulithUserApiUrl('auth/refresh-token'),
          {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Accept-Language': localStorage.getItem('umi_locale') || 'zh-CN',
            },
            body: JSON.stringify({ refreshToken }),
          },
        );
        if (!response.ok) {
          return false;
        }
        const json = await response.json();
        const data = parseRefreshResponse(json);
        if (!data?.accessToken) {
          return false;
        }
        persistAuthTokens({
          accessToken: data.accessToken,
          refreshToken: data.refreshToken,
        });
        return true;
      } catch {
        return false;
      } finally {
        refreshPromise = null;
      }
    })();
  }

  return refreshPromise;
};

export const isRefreshTokenRequest = (url?: string) =>
  Boolean(url?.includes('auth/refresh-token'));
